/*
 * Copyright ou © ou Copr. Université de Lorraine, (2022)
 *
 * Direction du Numérique de l'Université de Lorraine - SIED
 *  (dn-mobile-dev@univ-lorraine.fr)
 * JNESIS (contact@jnesis.com)
 *
 * Ce logiciel est un programme informatique servant à rendre accessible
 * sur mobile divers services universitaires aux étudiants et aux personnels
 * de l'université.
 *
 * Ce logiciel est régi par la licence CeCILL 2.1, soumise au droit français
 * et respectant les principes de diffusion des logiciels libres. Vous pouvez
 * utiliser, modifier et/ou redistribuer ce programme sous les conditions
 * de la licence CeCILL telle que diffusée par le CEA, le CNRS et INRIA
 * sur le site "http://cecill.info".
 *
 * En contrepartie de l'accessibilité au code source et des droits de copie,
 * de modification et de redistribution accordés par cette licence, il n'est
 * offert aux utilisateurs qu'une garantie limitée. Pour les mêmes raisons,
 * seule une responsabilité restreinte pèse sur l'auteur du programme, le
 * titulaire des droits patrimoniaux et les concédants successifs.
 *
 * À cet égard, l'attention de l'utilisateur est attirée sur les risques
 * associés au chargement, à l'utilisation, à la modification et/ou au
 * développement et à la reproduction du logiciel par l'utilisateur étant
 * donné sa spécificité de logiciel libre, qui peut le rendre complexe à
 * manipuler et qui le réserve donc à des développeurs et des professionnels
 * avertis possédant des connaissances informatiques approfondies. Les
 * utilisateurs sont donc invités à charger et à tester l'adéquation du
 * logiciel à leurs besoins dans des conditions permettant d'assurer la
 * sécurité de leurs systèmes et/ou de leurs données et, plus généralement,
 * à l'utiliser et à l'exploiter dans les mêmes conditions de sécurité.
 *
 * Le fait que vous puissiez accéder à cet en-tête signifie que vous avez
 * pris connaissance de la licence CeCILL 2.1, et que vous en avez accepté les
 * termes.
 */

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { AppUpdateModule } from '@multi/app-update';
import { AuthModule } from '@multi/auth';
import { CalendarModule } from '@multi/calendar';
import { CardsPageModule } from '@multi/cards';
import { ChatbotModule } from '@multi/chatbot';
import { ClockingModule } from '@multi/clocking';
import { ContactUsModule } from '@multi/contact-us';
import { ContactsModule } from '@multi/contacts';
import { ImportantNewsModule } from '@multi/important-news';
import { MapModule } from '@multi/map';
import { NotificationsModule } from '@multi/notifications';
import { ReservationModule } from '@multi/reservation';
import { RestaurantsModule } from '@multi/restaurants';
import { RssPageModule } from '@multi/rss';
import { ScheduleModule } from '@multi/schedule';
import { SocialNetworkModule } from '@multi/social-network';
import { StaticPagesModule } from '@multi/static-pages';
import { UnreadMailModule } from '@multi/unread-mail';
import { MatomoModule } from 'ngx-matomo';


import firebasePwaEnvironment from './firebase/web/firebase-environment.pwa.json';

export const environment: any = {
  firebase: firebasePwaEnvironment,
  production: false,
  // apiEndpoint: 'http://localhost:3000',
  apiEndpoint: 'https://mobile-back.unimes.fr',
  languages: ['fr', 'en'],
  defaultLanguage: 'fr',
  // cmsPublicAssetsEndpoint: 'http://localhost:8055/assets/',
  cmsPublicAssetsEndpoint: 'https://mobile-cms.unimes.fr/assets/',
  guidedTourEnabled: true,
  appTitle: 'Esup-Multi',
  appVersion: '1.0.0',
  enabledModules: [
    AppUpdateModule,
    AuthModule,
    CalendarModule.forRoot({
      numberOfEventsLimit: 3,
      display: 'list',
    }),
    CardsPageModule.forRoot({ knownErrors: ['NO_PHOTO', 'NO_ACTIVE_CARD', 'UNPAID_FEES'] }),
    ChatbotModule.forRoot({ chatbotLogoRegex: /_chacha5/i }),
    ClockingModule,
    ContactUsModule,
    ContactsModule.forRoot({ contactTypes: ['STUDENT', 'STAFF', 'STANDIN'] }),
    ImportantNewsModule.forRoot({
      display: 'vertically'
    }),
    MapModule.forRoot({
      defaultMapLocation: {
        longitude: 2.3488596,
        latitude: 48.8533249
      }
    }),
    NotificationsModule.forRoot({
      numberOfNotificationsOnFirstLoad: 20,
      numberOfNotificationsToLoadOnScroll: 10
    }),
    ReservationModule.forRoot({
      reservationSsoServiceName: 'https://mon-espace-de-resa.fr',
      reservationSsoUrlTemplate: 'https://mon-espace-de-resa.fr/auth?ticket={st}',
    }),
    RestaurantsModule,
    RssPageModule.forRoot({
      latestNewsWidget: {
        display: 'horizontally'
      },
      display: 'vertically'
    }),
    ScheduleModule.forRoot({
      nextEventsWidget: {
        numberOfEventsLimit: 2,
        numberOfDaysLimit: 7,
        display: 'list'
      },
      previousWeeksInCache: 1,
      nextWeeksInCache: 2,
      managerRoles: ['schedule-manager', 'multi-admin']
    }),
    SocialNetworkModule,
    StaticPagesModule,
    UnreadMailModule,
    MatomoModule.forRoot({
      scriptUrl: 'https://stats.unimes.fr/matomo.js',
      trackers: [
        {
          trackerUrl: 'https://stats.unimes.fr/matomo.php',
          siteId: 453
        }
      ],
      routeTracking: {
        enable: true
      }
    }),
  ],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
